import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
} from '@mui/material';
import { X } from '@phosphor-icons/react';
import { useState } from 'react';
import type { FlowRunStatus } from '../../types/flow-execution.types';
import ExecutionDetail from './ExecutionDetail';
import ExecutionsList from './ExecutionsList';

interface Props {
  open: boolean;
  onClose: () => void;
  flowId: string;
  flowName?: string;
}

function FlowExecutionsModal({ open, onClose, flowId, flowName }: Props) {
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState<FlowRunStatus | 'all'>('all');
  const [selectedExecId, setSelectedExecId] = useState<string | null>(null);
  const [expandedNodeIds, setExpandedNodeIds] = useState<Set<string>>(
    new Set(),
  );
  function handleStatusChange(next: FlowRunStatus | 'all') {
    setStatus(next);
    setPage(1);
  }
  function handleSelectExec(execId: string) {
    setSelectedExecId(execId);
    setExpandedNodeIds(new Set());
  }
  function handleToggleNode(id: string) {
    setExpandedNodeIds(current => {
      const next = new Set(current);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }
  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span>Executions{flowName ? ` — ${flowName}` : ''}</span>
        <IconButton onClick={onClose} size='small' aria-label='Close'>
          <X size={18} />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 0, height: '70vh' }}>
        <Stack direction='row' sx={{ height: '100%' }}>
          <Box
            sx={{
              width: 360,
              flexShrink: 0,
              borderRight: '1px solid',
              borderColor: 'divider',
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }}
          >
            <ExecutionsList
              flowId={flowId}
              page={page}
              status={status}
              selectedExecId={selectedExecId}
              onSelect={handleSelectExec}
              onPageChange={setPage}
              onStatusChange={handleStatusChange}
            />
          </Box>
          <Box sx={{ flex: 1, p: 2, overflowY: 'auto', minWidth: 0 }}>
            <ExecutionDetail
              flowId={flowId}
              execId={selectedExecId}
              expandedNodeIds={expandedNodeIds}
              onToggleNode={handleToggleNode}
            />
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default FlowExecutionsModal;
